import { render, staticRenderFns } from "./AusPricing.vue?vue&type=template&id=603ac996"
import script from "./AusPricing.vue?vue&type=script&lang=js"
export * from "./AusPricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports